// import DataHandlerStore from './DataHandler';
import ChatBotStore from './ChatBotStore';
import CookieStore from './CookieStore';
import FooterTextStore from './FooterTextStore';
import GrowthCalculatorStore from './GrowthCalculatorStore';
import NavigationStore from './NavigationStore';
import AppStore from './AppStore';
import PageStore from './PageStore';

const stores = {
    // DataHandlerStore,
    AppStore,
    PageStore,
    CookieStore,
    ChatBotStore,
    NavigationStore,
    FooterTextStore,
    GrowthCalculatorStore,
};

export default stores;
